// extracted by mini-css-extract-plugin
export default {"label_name":"AdminTool_label_name__mmDtG","label_name_swipe":"AdminTool_label_name_swipe__Pmgxl"};